// Characters that are hostile to file systems and S3 object keys:
// path separators, reserved Windows characters, and C0 control codes.
const HOSTILE_CHARS_REGEX = /[/\\:*?"<>|\u0000-\u001F]/g;

const DEFAULT_FILE_NAME = 'report';

export const normalizeName = (value) => {
  if (typeof value !== 'string') return value;
  return value.replace(/\s+/g, ' ').trim();
};

export const sanitizeFileName = (value) => {
  const normalized = typeof value === 'string' ? normalizeName(value) : '';
  const sanitized = normalized.replace(HOSTILE_CHARS_REGEX, '');
  return sanitized.length > 0 ? sanitized : DEFAULT_FILE_NAME;
};
